class AdManager {
  initMovieReward = () => {}
  playMovieReward = () => {}
  loadMovieReward = () => {}
  adViewingComplete = async () => {}
}

export default new AdManager()
